import LazyLoad from "vanilla-lazyload";

export function lazyLoad() {
  var lazyLoadInstance = new LazyLoad({
    elements_selector: ".lazy",
    // cancel_on_exit: true
  });

  function lazyReInit(){
    lazyLoadInstance.update();
  }
  window.addEventListener("orientationchange", lazyReInit);
}
